import { hookstate, none, useHookstate } from "@hookstate/core";
import { devtools } from "@hookstate/devtools";

const store = hookstate(
  {
    initialized: true, // Add at least one property
  },
  devtools({ key: "GlobalMiscState" })
);

const wrapState = (state) => ({
  get: (prop) => state[prop].value,
  set: (prop, value) => state[prop].set(value),
  add: (prop, value) => state[prop].merge(value),
  setNoneFirst: (prop, propFirst) => state[prop][propFirst].set(none),
  setBatch: (value) => state.merge(value),
});

export const useGlobalMiscState = () => wrapState(useHookstate(store));
export const accessGlobalMiscState = () => wrapState(store);
